import { Component, ElementRef, OnInit, Renderer2, ViewChild } from "@angular/core";
import { BaseServiceService } from "src/app/services/base-service.service";
import { DataTableComponent } from "../controls/data-table/data-table.component";
import {
  ModalNotifyComponent,
  ModalNotifyTypes,
} from "../modal-notify/modal-notify.component";
import { DataTableDirective } from "angular-datatables";
import { HttpClient } from "@angular/common/http";
import { AppData } from "src/app/helpers/app-data";
import { Router } from "@angular/router";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

declare var fabric: any;

@Component({
  selector: "app-grupo",
  templateUrl: "./grupo.component.html",
  styleUrl: "./grupo.component.css",
})
export class GrupoComponent implements OnInit {
  @ViewChild(DataTableComponent) dataTableComponent!: DataTableComponent;
  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;
  @ViewChild('dataTableAddUsuarios', { static: false }) dataTableAddUsuarios: ElementRef;

  dialogComponentCreateGrupo: any;
  dialogComponentEditGrupo: any;
  dialogComponentUsuariosPermitidos: any;
  dialogComponentAñadirUsuario: any;
  formSubmitted: boolean = false;
  botonProcesando = false;
  textoBotonProcesando = "Cargando...";
  idGrupo: any;

  @ViewChild(DataTableDirective, { static: false })
  dtElement: any;
  dtInstance: DataTables.Api;

  dtOptions: DataTables.Settings = {};
  dtOptButtons: any = [];
  dtOptionsUsuariosPermitidos: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    serverSide: false, // Cambiado a false, porque los datos no se cargan desde el servidor
    processing: true,
    searching: true,
    ordering: true,
    data: [],
    columns: [
      { title: "ID", data: "Id" },
      { title: "Nombre", data: "name" },
    ],
    language: {
      url: "../../../assets/es-ES.json",
    },
  };
  dtOptionsAddUsuarios: DataTables.Settings = {};
  response: any[] = [];
  titulo: string = "";
  internalDescription: string = "";
  dtTrigger: any;
  valorCompartido: any;
  validateDel: boolean = false;
  getDataTableGrupo: any = ["GrupoUsuario","GetDataTableGrupo"];
  getDataTableUsuarios: string = "Usuario/GetDataTableUsuario";
  groupForm: FormGroup;
  grupoObj: Grupo;

  booleanColumnRenderer = (data: any, type: any, row: any, meta: any) => {
    if (type === "display") {
      return `<input type="checkbox" disabled ${data ? "checked" : ""}>`;
    }
    return data;
  };

  columnas = [
    { title: "Grupo", data: "NombreGrupo" },
    { title: "Descripcion", data: "Descripcion" },
    { title: "Activo", data: "Activo", render: this.booleanColumnRenderer },

    /* { title: 'Configuracion', data: 'Configuracion' }, */
    /*  { title: 'Procesos', data: 'TodosProcesos', render: this.booleanColumnRenderer },
    { title: 'Formularios', data: 'TodosFormularios', render: this.booleanColumnRenderer },
    { title: 'Tareas', data: 'TodasTareas', render: this.booleanColumnRenderer },
    { title: 'Usuarios', data: 'Usuarios' }, */
  ];

  constructor(
    private baseService: BaseServiceService,
    private renderer: Renderer2,
    private http: HttpClient,
    private router: Router,
    private _formBuilder:FormBuilder
  ) {
    this.grupoObj = new Grupo();
    this.formInit();
  }

  /* Datatable */

  async ngOnInit(): Promise<void> {
    this.baseService.abrirModalEditar$.subscribe(() => {
      this.abrirModalEditar();
    });

    
    this.dtOptButtons.push({'button-id': 'btnEdit', 'button-icon': 'ms-Icon--EditNote', "button-tooltip": "Editar" }, 
      /* {'button-id': 'btnDelete', 'button-icon': 'ms-Icon--Delete'},  */
      {'button-id': 'btnAñadirUsuario', 'button-icon': 'ms-Icon--FollowUser', "button-tooltip": "Permisos" })
    

    // this.dtOptions = {
    //   pagingType: "full_numbers",
    //   pageLength: 10,
    //   serverSide: true,
    //   processing: true,
    //   searching: true,
    //   ordering: true,
    //   ajax: async (dataTablesParameters: any, callback) => {
    //     this.http
    //       .post<any>(AppData.API_URL + this.getDataTableGrupo, dataTablesParameters)
    //       .subscribe((resp) => {
    //         callback({
    //           draw: resp.Data.draw,
    //           recordsTotal: resp.Data.recordsTotal,
    //           recordsFiltered: resp.Data.recordsFiltered,
    //           data: resp.Data.data,
    //         });
    //       });
    //   },

    //   language: {
    //     url: "../../../assets/es-ES.json",
    //   },
    //   columns: [
    //     ...this.columnas
    //     // {
    //     //   title: "Opciones",
    //     //   data: "Id",
    //     //   orderable: false,
    //     //   render: (data: any, type: any, full: any) => {
    //     //     return `
    //     //   <button class="ms-CommandButton-button"  data-id="${full.Id}" id="btnEdit">
    //     //     <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--EditNote"></i></span>
    //     //   </button>
    //     //   <button class="ms-CommandButton-button" type="button" id="btnDelete" data-id="${full.Id}">
    //     //     <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete" ></i></span>
    //     //   </button>
    //     //   <button class="ms-CommandButton-button" type="button" id="btnAñadirUsuario" data-id="${full.Id}">
    //     //     <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--FollowUser" ></i></span>
    //     //   </button>
    //     // `;
    //     //   },
    //     // },
    //   ],
    // };



    this.dtOptionsAddUsuarios = {
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      searching: true,
      ordering: true,
      ajax: async (dataTablesParameters: any, callback) => {
        this.http
          .post<any>(AppData.API_URL + this.getDataTableUsuarios, dataTablesParameters)
          .subscribe((resp) => {
            callback({
              draw: resp.Data.draw,
              recordsTotal: resp.Data.recordsTotal,
              recordsFiltered: resp.Data.recordsFiltered,
              data: resp.Data.data,
            });
          });
      },

      language: {
        url: "../../../assets/es-ES.json",
      },
      columns: [
        { title: "Usuario", data: "NombreUsuario" },
        {
          title: "Opciones",
          data: "Id",
          orderable: false,
          render: (data: any, type: any, full: any) => {
            const checkboxName = `checkbox`;
            return `<input type="checkbox" id="${checkboxName}" name="${checkboxName}" />`;
          },
        },
      ],
    };


    var SpinnerElements = document.querySelectorAll(".ms-Spinner");
    for (var i = 0; i < SpinnerElements.length; i++) {
      new fabric["Spinner"](SpinnerElements[i]);
    }

  }
  attachCheckboxEvents(): void {
    const table = this.dataTableAddUsuarios.nativeElement;
    const checkboxes = table.querySelectorAll('input[type="checkbox"]');

    checkboxes.forEach((checkbox) => {
      this.renderer.listen(checkbox, 'change', (event) => {
        const checkboxName = checkbox.name;
        const checkboxState = checkbox.checked;

        // Extraer el ID del registro desde el nombre del checkbox
        

        /* console.log(`Estado: ${checkboxState}`); */

      });
    });
  }
  ngAfterViewInit(): void {
    // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.on("draw", () => {
    //     this.attachClickEvents();
    //   });
    // });
    if (this.dataTableAddUsuarios) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.on("draw", () => {
          this.attachCheckboxEvents();
        });
      });
    } else {
      console.error('Elemento dataTableAddUsuarios no está definido en ngAfterViewInit');
    }
  }

  ngOnDestroy(): void {
    // Destroy the DataTables when the component is destroyed to prevent memory leaks
    if (this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.off("draw");
      });
    }
  }

  formInit()
  {
    this.groupForm = this._formBuilder.group({
      NombreGrupo: new FormControl('', [Validators.required, Validators.maxLength(200)]),
      Descripcion: new FormControl('', [Validators.required, Validators.maxLength(300)]),
      Activo: new FormControl(false)
    });
  }

  
  gridLoaded(event: any)
  {
    this.dtInstance = event['table'];
  }

  customClick(event: any)
  {
    try {
      
      this.idGrupo = event["data-id"];

      switch(event['button-id'])
      {
        case 'btnEdit':
          this.abrirModalEditar();
          break;
        case 'btnDelete':
          this.delete();
          break;
        case 'btnAñadirUsuario':
          this.baseService.exportIdGrupo(this.idGrupo)
          this.abrirUsuariosPermitidos();
          break;
      }
      
    } catch (error) {
      console.error("Error al retornar evento datatable", error);
    }
  }

  delete() {
    try {
      
      this.baseService.triggerShowModal(
        "Eliminar Grupo",
        "¿Seguro que desea eliminar el Grupo?",
        ModalNotifyTypes.Warning,
        true
      );


      this.modalNotifyComponent.actionConfirmed.subscribe(
        (confirmed: boolean) => {
          if (confirmed) {
            
            this.baseService
              .delete("GrupoUsuario/BorrarGrupo", this.idGrupo)
              .then(() => {
                this.reloadDataTable();
                this.idGrupo = null;
                this.baseService.triggerShowModal(
                  "Grupo Eliminado",
                  "Grupo Eliminado Correctamente",
                  ModalNotifyTypes.Success,
                  false
                );
              });
          } else {
            
          }
        }
      );
    } catch (error: any) {
      this.baseService.triggerShowModal(
        "Error al enviar el formulario:",
        error,
        ModalNotifyTypes.Danger,
        false
      );
    }
  }

  reloadDataTable(): void {
    // Obtener la instancia de DataTable y recargar los datos
    // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.ajax.reload(null, false); // false para mantener la página actual después de la recarga
    // });

    this.dtInstance.ajax.reload(null,false)

  }

  /* Fin Datatable */

  abrirModalCrear() {
    this.clearFormGrupoCreado();
    this.groupForm.controls["Activo"].setValue(true);

    $('#dialogCreateEdit').html('Crear Grupo');
    $('#btnCreateEdit > span').html('Crear');
    const dialog = document.querySelector(".create-grupo");
    this.dialogComponentCreateGrupo = new fabric["Dialog"](dialog);
    this.dialogComponentCreateGrupo.open();
  }

  async crearEditarGrupo() {
    // this.validateForm();
    // if (this.validateForm()) {
      this.botonProcesando = true; 
      this.grupoObj.NombreGrupo = this.groupForm.get('NombreGrupo').value;
      this.grupoObj.Descripcion = this.groupForm.get('Descripcion').value;
      this.grupoObj.Activo = this.groupForm.get('Activo').value;
      this.grupoObj.TodasTareas = true;
      this.grupoObj.TodosFormularios = true;
      this.grupoObj.TodosProcesos = true;

      try {
        if(this.idGrupo)
        {
          const response = await this.baseService.update(
            "GrupoUsuario/ActualizarGrupo",
            this.idGrupo,
            this.grupoObj
          );
  
          if (!response.Ok) {
            this.dialogComponentEditGrupo.close();
  
            let mensajeError = "<ul>";
            response.ValidationErrors.forEach((error: any) => {
              mensajeError += `<li>${error}</li>`;
            });
            mensajeError += "</ul>";
  
            this.baseService.triggerShowModal(
              "Error al editar Grupo",
              mensajeError,
              ModalNotifyTypes.Danger,
              false
            );
          } else {
            this.dialogComponentCreateGrupo.close();
            this.baseService.triggerShowModal(
              "Grupo Editado",
              "Se ha almacenado el registro correctamente ",
              ModalNotifyTypes.Success,
              false
            );
          }
        }
        else
        {
          const response = await this.baseService.create(
            "GrupoUsuario/CrearGrupo",
            this.grupoObj
          );
  
          if (!response.Ok) {
            this.dialogComponentCreateGrupo.close();
  
            let mensajeError = "<ul>";
            response.ValidationErrors.forEach((error: any) => {
              mensajeError += `<li>${error}</li>`;
            });
            mensajeError += "</ul>";
  
            this.baseService.triggerShowModal(
              "Error al crear Grupo",
              mensajeError,
              ModalNotifyTypes.Danger,
              false
            );
          } else {
            this.dialogComponentCreateGrupo.close();
            this.baseService.triggerShowModal(
              "Grupo Creado",
              "Se ha almacenado el registro correctamente ",
              ModalNotifyTypes.Success,
              false
            );
          }
        }

        this.botonProcesando = false;
        this.reloadDataTable();
        //this.clearFormGrupoCreado();

      } catch (error: any) {
        this.dialogComponentCreateGrupo.close();

      let mensajeError = error.error.Error;
      
      this.baseService.triggerShowModal(
        "Error",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
      }
    // } else {
    //   this.botonProcesando = false;
    // }
  }

  async abrirModalEditar() {
    try {
      if (this.idGrupo !== null) {
        const responseById = await this.baseService.getById(
          "GrupoUsuario/GetGrupo",
          this.idGrupo
        );
        if (responseById.Data) {
          const Data = responseById.Data;
          this.groupForm.controls['NombreGrupo'].setValue(Data.NombreGrupo);
          this.groupForm.controls['Descripcion'].setValue(Data.Descripcion);
          this.groupForm.controls['Activo'].setValue(Data.Activo);

          $('#dialogCreateEdit').html('Editar Grupo');
          $('#btnCreateEdit > span').html('Actualizar');

          const selectedOption =
            document.querySelectorAll(".ms-Dropdown-title");

          selectedOption.forEach((selected) => {
            const fieldNameElement = selected.parentNode as HTMLElement;
            const dropdownSelect = fieldNameElement.querySelector(
              ".ms-Dropdown-select"
            );
            const fieldName = dropdownSelect?.getAttribute("name");
            const fieldValue = fieldName ? Data[fieldName] : null;
            if (fieldValue) {
              selected.textContent = fieldValue;
            }
          });

          const dialog = document.querySelector(".create-grupo");

          this.dialogComponentCreateGrupo = new fabric["Dialog"](dialog);
          this.dialogComponentCreateGrupo.open();
        } 
      }
    } catch (error: any) {
      this.baseService.triggerShowModal(
        "Error",
        error.Error,
        ModalNotifyTypes.Danger,
        false
      );
    }
  }


  clearFormGrupoCreado() {
    this.grupoObj = new Grupo();
    this.groupForm.reset();
    this.idGrupo = null;
    //this.baseService.clearForm();
  }



  clearFormGrupo() {

    this.baseService.triggerShowModal(
      "Cancelar creacion de Grupo",
      "¿Seguro que desea cancelar la creacion del grupo?",
      ModalNotifyTypes.Warning,
      true
    );

    //this.baseService.clearForm();

    this.modalNotifyComponent.actionConfirmed.subscribe(
      (confirmed: boolean) => {
        if (confirmed) {
          this.grupoObj = new Grupo();
          this.groupForm.reset();
          this.idGrupo = null;
          this.dialogComponentCreateGrupo.close();

         
        } else {
          // Si se cancela la eliminación, no hacemos nada
        }
      }
    );
  }

  /* Añadir Usuario */

  abrirUsuariosPermitidos() {
    this.router.navigate(["home/usuarios-permitidos"]);

  }

/*   abrirModalAnadirUsuarios() {
    if (this.dialogComponentUsuariosPermitidos) {
      this.dialogComponentUsuariosPermitidos.close();
      console.log("entra");
    }
    const dialogAdd = document.querySelector(".añadir-usuario");
    this.dialogComponentAñadirUsuario = new fabric["Dialog"](dialogAdd);
    this.dialogComponentAñadirUsuario.open();
  } */
}

export class Grupo {
  NombreGrupo: string;
  Descripcion: string;
  Configuracion: string;
  TodosProcesos: boolean;
  TodosFormularios: boolean;
  TodasTareas: boolean;
  Activo: boolean;
  Usuarios: string;

  constructor() {
    (this.NombreGrupo = ""),
      (this.Descripcion = ""),
      (this.Configuracion = ""),
      (this.TodosProcesos = undefined),
      (this.TodosFormularios = undefined),
      (this.TodasTareas = undefined),
      (this.Activo = undefined),
      (this.Usuarios = "");
  }
}
